import { http } from './axios'

class SettingService {
  saveGeneralSetting (data) {
    return http.post('setting/general/save', data)
  }
  saveMessageSetting (data) {
    return http.post('setting/message/save', data)
  }
  getGeneralSettings () {
    return http.get('setting/general')
  }
  getMessageSettings () {
    return http.get('setting/message')
  }
}
export default new SettingService()
